import { Matrix } from "../Maths/math.vector";
/**
 * Configuration needed for prepass-capable materials
 */
var PrePassConfiguration = /** @class */ (function () {
    function PrePassConfiguration() {
        /**
         * Previous world matrices of meshes carrying this material
         * Used for computing velocity
         */
        this.previousWorldMatrices = {};
        /**
         * Previous bones of meshes carrying this material
         * Used for computing velocity
         */
        this.previousBones = {};
    }
    /**
     * Add the required uniforms to the current list.
     * @param uniforms defines the current uniform list.
     */
    PrePassConfiguration.AddUniforms = function (uniforms) {
        uniforms.push("previousWorld", "previousViewProjection");
    };
    /**
     * Add the required samplers to the current list.
     * @param samplers defines the current sampler list.
     */
    PrePassConfiguration.AddSamplers = function (samplers) {
        // pass
    };
    /**
     * Binds the material data.
     * @param effect defines the effect to update
     * @param scene defines the scene the material belongs to.
     * @param mesh The mesh
     * @param world World matrix of this mesh
     * @param isFrozen Is the material frozen
     */
    PrePassConfiguration.prototype.bindForSubMesh = function (effect, scene, mesh, world, isFrozen) {
        if (scene.prePassRenderer && scene.prePassRenderer.enabled) {
            if (scene.prePassRenderer.getIndex(2) !== -1) {
                if (!this.previousWorldMatrices[mesh.uniqueId]) {
                    this.previousWorldMatrices[mesh.uniqueId] = Matrix.Identity();
                }
                if (!this.previousViewProjection) {
                    this.previousViewProjection = scene.getTransformMatrix();
                }
                effect.setMatrix("previousWorld", this.previousWorldMatrices[mesh.uniqueId]);
                effect.setMatrix("previousViewProjection", this.previousViewProjection);
                this.previousWorldMatrices[mesh.uniqueId] = world.clone();
                this.previousViewProjection = scene.getTransformMatrix().clone();
            }
        }
    };
    return PrePassConfiguration;
}());
export { PrePassConfiguration };
//# sourceMappingURL=prePassConfiguration.js.map